import { VictoryChart, VictoryLine, VictoryTooltip, VictoryVoronoiContainer } from 'victory';
import NoData from '../../../../../../components/NoData';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import { ListaTotaisPeriodo } from '../../../types';
import { Card } from './styles';

interface ILastMonthsRoutingAmount {
  lastMonthsHistoric: ListaTotaisPeriodo[]
}

export default function LastMonthsRoutingAmount({ lastMonthsHistoric }: ILastMonthsRoutingAmount) {
  if (!lastMonthsHistoric) {
    return;
  }
  const largestConsultsAmount = Math.max(...lastMonthsHistoric.map((x) => x.totalConsultas));
  const smallestConsultsAmount = Math.min(...lastMonthsHistoric.map((x) => x.totalConsultas));

  return (
    <Card>
      <div className="card-title">
        <div>Consultas realizadas nos últimos 12 meses (em relação ao atual)</div>
      </div>

      {(!!lastMonthsHistoric && lastMonthsHistoric.length > 0) && (
        <>
          <OpacityAnimation>
            <div className="card-main-graph-line">
              <VictoryChart
                height={100}
                width={300}
                padding={{
                  top: 15, bottom: 30, left: 25, right: 20,
                }}
                maxDomain={{ y: largestConsultsAmount * 1.05 }}
                minDomain={{ y: smallestConsultsAmount * 0.95 }}
                containerComponent={(
                  <VictoryVoronoiContainer
                    labels={({ datum }) => `${datum.x}, ${datum.y} consultas`}
                    labelComponent={(
                      <VictoryTooltip
                        constrainToVisibleArea
                        centerOffset={{ x: 5, y: 40 }}
                        style={{ fill: 'black' }}
                        flyoutHeight={20}
                        flyoutWidth={70}
                      />
                    )}
                  />
                )}
              >
                <VictoryLine
                  style={{
                    data: { stroke: '#4aafff', strokeWidth: 1 },
                    parent: { border: 'none' },
                  }}
                  data={lastMonthsHistoric.map((data) => (
                    { x: `${data.mes} / ${data.ano}`, y: data.totalConsultas }
                  ))}
                  interpolation="natural"
                  animate={{
                    duration: 3000,
                    onLoad: { duration: 5000 },
                  }}
                />
              </VictoryChart>
            </div>
          </OpacityAnimation>
        </>
      )}

      {(!lastMonthsHistoric || lastMonthsHistoric.length === 0) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados disponíveis sobre quantidade de consultas nos últimos 12 meses.
            </>
          )}
        />
      )}
    </Card>
  );
}
